var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { AvatarLetter } from '.';
import { AvatarWithLabel } from '../AvatarWithLabel';
/**
 * AvatarWithLabel with preset props for users
 * Uses <AvatarLetter> based on the title's first character
 */
export function UserAvatar(props) {
    const { title } = props, restProps = __rest(props, ["title"]);
    const firstLetter = (title === null || title === void 0 ? void 0 : title.trim().toUpperCase().charAt(0).toUpperCase()) || 'A';
    const secondLetter = (title === null || title === void 0 ? void 0 : title.trim().toUpperCase().charAt(1).toUpperCase()) || 'B';
    const colors = [
        'success',
        'danger',
        'magenta',
        'cyan',
        'info',
        'warning',
        'orange',
        'brown',
        'indigo',
        'secondary',
    ];
    const code = firstLetter.charCodeAt(0) + secondLetter.charCodeAt(0);
    const charCode = code % colors.length;
    const color = colors[charCode];
    return (<AvatarWithLabel solid appearance={color} title={title} {...restProps}>
      <AvatarLetter>{firstLetter}</AvatarLetter>
    </AvatarWithLabel>);
}
